<template>
<div v-if="list && list.length">
    <bread-crumb :vector="[{fa : 'فروشگاه '+ supplierName,path : '/store/'+supplierID},{fa : name,path : '/Category/mainGroup/groups/'+route.params.id+'/'+supplierID}]" v-if="supplierName && name"/>
    <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5">
        <div class="sc-d8w7bo-1 jpdybm">
            <div class="d-flex flex-wrap" style="padding-inline: 3px;gap: 1px;">
            <product-border :list="list" />
            </div>
        </div>
    </section>
</div>
<Loading v-else page="group" />

</template>

<script setup>
import { useRoute } from 'vue-router';
import { ref } from 'vue'
import ProductBorder from '@/components/section/item/ProductBorder.vue';
import BreadCrumb from "@/components/section/item/BreadCrumb.vue";
import Loading from "../../../../section/item/loading.vue";

let route = useRoute()
let list = ref([]);
let name = ref('');
let supplierID = ref();
let supplierName = ref('');
getItems()
async function getItems(){
    let respons = await fetch('https://radap.ir/Backend/api/section/pages/store/whole_main.php?id='+route.params.id)
    let data = await respons.json()
    list.value = data.items;
    name.value = data.name;
    supplierName.value = data.supplier_name;
    supplierID.value = data.supplier_id;
}
</script>
